import { FC } from 'react';
import styled from 'styled-components';

import Text from '@/components/Text';

const StatusText = styled(Text)`
  display: flex;
  align-items: center;
  gap: 6px;
`;

interface Props {
  status: string;
}

const Status: FC<Props> = ({ status }) => {
  if (status === 'done') {
    return (
      <StatusText as="div" $type="smallHeadline">
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z"
            fill="#42BE77"
          />
          <path
            d="M9.96214 5.38464L6.0134 9.15387L4.03906 7.26926"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        Done
      </StatusText>
    );
  }

  if (status === 'failed') {
    return (
      <StatusText as="div" $type="smallHeadline">
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z"
            fill="#F64629"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.71064 5.70711C10.1012 5.31658 10.1012 4.68342 9.71064 4.29289C9.32011 3.90237 8.68695 3.90237 8.29642 4.29289L7.00177 5.58755L5.70711 4.29289C5.31658 3.90237 4.68342 3.90237 4.29289 4.29289C3.90237 4.68342 3.90237 5.31658 4.29289 5.70711L5.58755 7.00177L4.29289 8.29642C3.90237 8.68695 3.90237 9.32011 4.29289 9.71064C4.68342 10.1012 5.31658 10.1012 5.70711 9.71064L7.00177 8.41598L8.29642 9.71064C8.68695 10.1012 9.32011 10.1012 9.71064 9.71064C10.1012 9.32011 10.1012 8.68695 9.71064 8.29642L8.41598 7.00177L9.71064 5.70711Z"
            fill="white"
          />
        </svg>
        Failed
      </StatusText>
    );
  }

  return (
    <StatusText as="div" $type="smallHeadline">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14px"
        height="14px"
        viewBox="0 0 24 24"
      >
        <path
          fill="#42BE77"
          d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"
          opacity=".25"
        ></path>
        <path
          fill="#42BE77"
          d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z"
        >
          <animateTransform
            attributeName="transform"
            dur="0.75s"
            repeatCount="indefinite"
            type="rotate"
            values="0 12 12;360 12 12"
          ></animateTransform>
        </path>
      </svg>
      Pending
    </StatusText>
  );
};

export default Status;
